import { useQueryClient } from '@tanstack/react-query';
import { useThemePageStore } from '~/stores/themePage';
import { useCallback } from 'react';

export const useRefetchThemePage = () => {
  const queryClient = useQueryClient();

  const isReFetchedThemePages = useThemePageStore((state) => state.isReFetchedThemePages);
  const setIsReFetchedThemePages = useThemePageStore((state) => state.setIsReFetchedThemePages);

  const refetch = useCallback(async () => {
    setIsReFetchedThemePages(false);

    const queryKeys = ['ThemePages'];
    await queryClient.refetchQueries({
      predicate: (query) => {
        if (!query.queryKey[1]) return false;
        return queryKeys.includes(query.queryKey[0] as string);
      },
    });
    setIsReFetchedThemePages(true);
  }, [queryClient, setIsReFetchedThemePages]);

  return {
    refetch,
    isReFetchedThemePages,
  };
};
